<template>
  <v-col
    v-if="currentlyImpersonating"
    cols="12"
    class="mt-n3"
  >
    <v-banner
      app
      single-line
      sticky
      icon="mdi-account"
      class="grey lighten-2"
    >
      Impersonation in progress...
      <template v-slot:actions>
        <v-btn
          text
          color="deep-orange accent-4"
          @click="stopImpersonating"
        >
          Stop Impersonate
        </v-btn>
      </template>
    </v-banner>
  </v-col>
</template>

<script>
import CompanyRest from '../../rest/CompanyRest'

export default {
  computed: {
    currentlyImpersonating () {
      return this.$auth.isImpersonating
    }
  },
  methods: {
    stopImpersonating () {
      CompanyRest.StopImpersonate(this.$auth.company_id).then(response => {
        this.$router.push({ name: 'home' })
        // need to reload the page to update user name
        this.$router.go(0)
      })
    }
  }
}
</script>
